import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { flow, pipe } from 'fp-ts/lib/function'
import { Table, Button } from 'antd'
import { array } from 'fp-ts'
import { FormattedMessage, FormattedDate } from 'react-intl'
import {
  stepBackAction,
  AssignableKeys,
  IndexBill,
  withDefaults,
  confirmUploadAction,
} from './types'
import styled from 'styled-components'
import Amount from '../Amount'
import { useMode } from '../Bills/queries'

const ButtonRow = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

type BillData = {
  [k in AssignableKeys]: k extends 'taxRate' | 'discountRate'
    ? number | undefined
    : IndexBill<k>
}

function render<K extends AssignableKeys>(
  k: K,
  renderData: (_: BillData[K]) => JSX.Element
) {
  return (_: any, b: BillData) => renderData(b[k])
}

const ConfirmUpload = () => {
  const dispatch = useDispatch()
  const data = useSelector(s =>
    s.upload.state === 'Confirm'
      ? pipe(s.upload.finalData, array.map(withDefaults))
      : []
  )
  const mode = useMode()

  return (
    <>
      <Table
        size="small"
        dataSource={data.map((v, i) => ({ ...v, key: i }))}
        columns={[
          {
            title: <FormattedMessage id="reference" />,
            dataIndex: 'reference',
            key: 'reference',
            render: render('reference', x => <>{x}</>),
          },
          {
            title: <FormattedMessage id="amount" />,
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            render: (_, b) => <Amount amount={b.amount} unit="" />,
          },
          {
            dataIndex: 'createdAt',
            title: <FormattedMessage id="date" />,
            render: render('createdAt', c => (
              <FormattedDate
                value={c}
                year="numeric"
                month="long"
                day="numeric"
              />
            )),
          },
          {
            dataIndex: 'dueAt',
            title: <FormattedMessage id="dueDate" />,
            render: render('dueAt', c => (
              <FormattedDate
                value={c}
                year="numeric"
                month="long"
                day="numeric"
              />
            )),
          },
        ]}
        pagination={false}
        scroll={{ x: true }}
      />
      <ButtonRow>
        <Button.Group>
          <Button onClick={flow(stepBackAction, dispatch)}>
            <FormattedMessage id="back" />
          </Button>
          <Button
            type="primary"
            onClick={() => dispatch(confirmUploadAction(mode))}
          >
            <FormattedMessage id="confirm" />
          </Button>
        </Button.Group>
      </ButtonRow>
    </>
  )
}

export default ConfirmUpload
